//
// Welcome to the annotated FaceTec Device SDK core code for performing secure Liveness Checks!
//
import { Config } from "../../Config";
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { i18nInstance } from "../../i18n";
import { sendLivenessMessage, sendSimpleLivenessEvent, } from "../../helpers/postMessageHelper";
import { FLOW_MODE } from "../../constants";
//
// This is an example self-contained class to perform Liveness Checks with the FaceTec SDK.
// You may choose to further componentize parts of this in your own Apps based on your specific requirements.
//
var LivenessCheckProcessor = /** @class */ (function () {
    function LivenessCheckProcessor(sessionToken, sampleAppControllerReference, options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        this.latestNetworkRequest = new XMLHttpRequest();
        this.onFaceTecSDKCompletelyDone = function () {
            _this.success = _this.latestSessionResult.isCompletelyDone;
            _this.sampleAppControllerReference.onComplete(_this.latestSessionResult, null, _this.latestNetworkRequest.status);
        };
        this.isSuccess = function () {
            return _this.success;
        };
        this.success = false;
        this.sampleAppControllerReference = sampleAppControllerReference;
        this.latestSessionResult = null;
        this.mode = options.mode || FLOW_MODE.LIVENESS;
        this.enrollmentId = options.enrollmentId || "";
        if (Config.InIframe) {
            new FaceTecSDK.FaceTecSessionFromIFrame(this, sessionToken);
        }
        else {
            new FaceTecSDK.FaceTecSession(this, sessionToken);
        }
    }
    LivenessCheckProcessor.prototype.processSessionResultWhileFaceTecSDKWaits = function (sessionResult, faceScanResultCallback) {
        var _a;
        var _this = this;
        var _b, _c, _d;
        this.latestSessionResult = sessionResult;
        if (sessionResult.status !==
            FaceTecSDK.FaceTecSessionStatus.SessionCompletedSuccessfully) {
            console.log("==> Session was not completed successfully. Status:", FaceTecSDK.FaceTecSessionStatus[sessionResult.status]);
            console.log("==> Full sessionResult object:", sessionResult);
            this.latestNetworkRequest.abort();
            console.log("==> Aborted latest network request.");
            if (FaceTecSDK.FaceTecSessionStatus[sessionResult.status] ===
                "UserCancelled") {
                console.log("==> User cancelled the session.");
                sendSimpleLivenessEvent("UserCancelled", "UserCancelled");
            }
            if (FaceTecSDK.FaceTecSessionStatus[sessionResult.status] ===
                "ContextSwitch") {
                console.log("==> Context switch detected.");
                sendSimpleLivenessEvent("ContextSwitch", "ContextSwitch");
            }
            if (sessionResult.status !== FaceTecSDK.FaceTecSessionStatus.ContextSwitch) {
                console.log("==> Sending message: ConnectionError.");
                sendLivenessMessage({
                    cmd: "recognition-response",
                    resultAction: "ConnectionError",
                    header: FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId),
                    code: sessionResult.status.toString(),
                });
                console.log("==> Message sent for ConnectionError.");
            }
            else {
                console.log("==> ContextSwitch detected. Enabling continue button.");
                var btnContinue = document.getElementById("liveness-button");
                btnContinue.disabled = false;
                document.getElementById("status").style.fontWeight = "bold";
                console.log("==> Button and status updated.");
            }
            faceScanResultCallback.cancel();
            console.log("==> faceScanResultCallback cancelled.");
            return;
        }
        console.log("==> Session completed successfully.");
        var parameters = {
            faceScan: sessionResult.faceScan || "",
            auditTrailImage: sessionResult.auditTrail[0] || "",
            lowQualityAuditTrailImage: sessionResult.lowQualityAuditTrail[0] || "",
            sessionId: sessionResult.sessionId || "",
        };
        if (this.enrollmentId) {
            parameters["externalDatabaseRefID"] = this.enrollmentId;
        }
        var operationByMode = (_a = {},
            _a[FLOW_MODE.LIVENESS] = ((_b = Config.faceTecOperations) === null || _b === void 0 ? void 0 : _b.liveness) || "liveness-3d",
            _a[FLOW_MODE.ENROLLMENT] = ((_c = Config.faceTecOperations) === null || _c === void 0 ? void 0 : _c.enrollment) || "enrollment-3d",
            _a[FLOW_MODE.AUTH_3D] = ((_d = Config.faceTecOperations) === null || _d === void 0 ? void 0 : _d.auth) || "match-3d-3d",
            _a);
        var options = "?op=" + operationByMode[this.mode] +
            (Config.logoId != "" ? "&file_id=" + Config.logoId : "") +
            "&version=k_" + Config.FaceTecVersion;
        if (this.enrollmentId) {
            options +=
                "&externalDatabaseRefID=" + encodeURIComponent(this.enrollmentId);
        }
        this.latestNetworkRequest = new XMLHttpRequest();
        this.latestNetworkRequest.open("POST", Config.BaseURL + options);
        this.latestNetworkRequest.setRequestHeader("Content-Type", "application/json");
        this.latestNetworkRequest.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
        this.latestNetworkRequest.setRequestHeader("X-User-Agent", FaceTecSDK.createFaceTecAPIUserAgentString(sessionResult.sessionId));
        this.latestNetworkRequest.onreadystatechange = function () {
            if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                try {
                    var responseJSON = JSON.parse(_this.latestNetworkRequest.responseText);
                    var scanResultBlob = responseJSON.scanResultBlob;
                    if (responseJSON.wasProcessed) {
                        if (responseJSON.success) {
                            faceScanResultCallback.succeed();
                            var btnContinue = document.getElementById("liveness-button");
                            var labelVersion = document.getElementById("version");
                            if (btnContinue) {
                                btnContinue.style.display = "none";
                                labelVersion.style.display = "none";
                            }
                        }
                        var successMessageKey = _this.mode === FLOW_MODE.ENROLLMENT
                            ? "facetec-enrollment-verified"
                            : _this.mode === FLOW_MODE.AUTH_3D
                                ? "facetec-auth-verified"
                                : "face-verified";
                        FaceTecSDK.FaceTecCustomization.setOverrideResultScreenSuccessMessage(i18nInstance.t(successMessageKey));
                        if (scanResultBlob) {
                            faceScanResultCallback.proceedToNextStep(scanResultBlob);
                        }
                        else {
                            faceScanResultCallback.succeed();
                        }
                    }
                    else {
                        console.log("Unexpected API response, cancelling out.");
                        faceScanResultCallback.cancel();
                    }
                }
                catch (_a) {
                    console.log("Exception while handling API response, cancelling out.");
                    faceScanResultCallback.cancel();
                }
            }
        };
        this.latestNetworkRequest.onerror = function () {
            console.log("XHR error, cancelling.");
            faceScanResultCallback.cancel();
        };
        this.latestNetworkRequest.upload.onprogress = function (event) {
            var progress = event.loaded / event.total;
            faceScanResultCallback.uploadProgress(progress);
        };
        var jsonStringToUpload = JSON.stringify(parameters);
        this.latestNetworkRequest.send(jsonStringToUpload);
        window.setTimeout(function () {
            if (_this.latestNetworkRequest.readyState === XMLHttpRequest.DONE) {
                return;
            }
            faceScanResultCallback.uploadMessageOverride("Still Uploading...");
        }, 6000);
    };
    return LivenessCheckProcessor;
}());
export { LivenessCheckProcessor };
